import React from "react";
import MarkdownSkeleton from "./MarkdownSkeleton";

interface LoadingOverlayProps {
  isLoading: boolean;
  children: React.ReactNode;
}

const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, children }) => {
  if (!isLoading) {
    return <>{children}</>;
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50 backdrop-blur-2xl">
      <div className="prose max-h-[80vh] overflow-y-auto p-8 markdown fade-in-up relative bg-white rounded-xl shadow-xl w-full max-w-2xl zoom-in">
        <div className="p-8">
          <MarkdownSkeleton />
        </div>
      </div>
    </div>
  );
};

export default LoadingOverlay; 